import { PATH } from './path';

export const serviceOptions = [
    { id: 'psychiatry', label: 'Psychiatry' },
    { id: 'weight-loss', label: 'Weight loss' },
    { id: 'primary-care', label: 'Primary care' },
    { id: 'counseling-therapy', label: 'Counseling & therapy' },
    { id: 'urgent-care', label: 'Urgent care' },
    { id: 'womens-health', label: "Women's health" },
    { id: 'mens-health', label: "Men's health" },
    { id: 'dermatology', label: 'Dermatology' },
    { id: 'others', label: 'Others' },
];

/**
 * Normalizes a path by removing leading and trailing slashes
 * @param path - The path to normalize
 * @returns Normalized path string
 */
export const normalizePath = (path: string): string => path?.replace(/^\/+|\/+$/g, '') || '';

/**
 * Public paths that don't require login authentication
 * These paths can handle auth errors without showing notification popups
 */
export const PUBLIC_PATHS = [
    PATH.PPA_LEAD_FORM,
    PATH.PPA_REDIRECT,
    PATH.PPA_LOGIN,
    PATH.PPA_RESET_PASSWORD,
    PATH.SWITCH_ACCOUNT_REDIRECT,
    PATH.SWITCH_ACCOUNT_NOTICE,
    PATH.PROVIDER_SELECT_ORG,
    PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
];

/**
 * Normalized public paths for comparison
 */
export const PUBLIC_PATHS_NORMALIZED = PUBLIC_PATHS.map(normalizePath);

/**
 * Checks if the current path is a public path that doesn't require login
 * @param currentPath - The current path to check
 * @returns True if the path is a public path that doesn't require login
 */
export const isPublicPath = (currentPath: string): boolean => {
    const normalizedCurrentPath = normalizePath(currentPath);
    return PUBLIC_PATHS_NORMALIZED.includes(normalizedCurrentPath);
};
